import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { SkipLink } from '../skip-link/SkipLink';

import styles from './skip-links.scss';

export const SkipLinks = ({ links }) => (
  <LinkList links={links} Item={SkipLink} className={styles.skip} />
);
